export default __webpack_public_path__ + "static/media/pause-icon.0ef7234e.svg";